module.exports = __webpack_public_path__ + "img/isotype.bb1c54e5.svg";